import { useEffect, useState } from "react";

import { scheduleScrollToDomId } from "../lib/scrollToDomId";

const HIGHLIGHT_MS = 2000;

/**
 * Deep-link focus for a record inside a section: once the list has loaded,
 * scroll `#<domId>` into view and report it as highlighted for two seconds.
 * `ready` gates the scroll until the element can exist.
 */
export const useFocusScroll = (
  domId: string | null | undefined,
  ready: boolean
): { highlightedId: string | null } => {
  const [highlightedId, setHighlightedId] = useState<string | null>(null);

  useEffect(() => {
    const id = (domId ?? "").trim();
    if (!id || !ready) return undefined;
    const cancelScroll = scheduleScrollToDomId(id);
    setHighlightedId(id);
    const timer = window.setTimeout(() => setHighlightedId(null), HIGHLIGHT_MS);
    return () => {
      cancelScroll();
      window.clearTimeout(timer);
    };
  }, [domId, ready]);

  return { highlightedId };
};
